var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
import { transient } from "aurelia-dependency-injection";
import { autoinject, noView } from "aurelia-framework";
var AsyncClickWithLoadingCustomAttribute = /** @class */ (function () {
    function AsyncClickWithLoadingCustomAttribute(element) {
        var _this = this;
        this.element = element;
        this.disabledProp = "disabled";
        this.loadingProp = "loading";
        this.internalClick = function ($event) {
            var viewModelElement = _this.element.au ? _this.element.au.controller.viewModel : _this.element;
            var loadingProp = _this.loadingProp ? _this.loadingProp : "loading";
            var disabledProp = _this.disabledProp ? _this.disabledProp : "disabled";
            if (viewModelElement[loadingProp] || (_this.element.au
                && _this.element.au.controller
                && _this.element.au.controller.viewModel["disabled"])) {
                return;
            }
            try {
                viewModelElement[loadingProp] = true;
                viewModelElement[disabledProp] = true;
                if (_this.click) {
                    var res = _this.click($event);
                    if (res instanceof Promise) {
                        res.then(function (x) {
                            viewModelElement[loadingProp] = false;
                            viewModelElement[disabledProp] = false;
                        }).catch(function (ex) {
                            viewModelElement[loadingProp] = false;
                            viewModelElement[disabledProp] = false;
                        });
                    }
                    else {
                        viewModelElement[loadingProp] = false;
                        viewModelElement[disabledProp] = false;
                    }
                }
            }
            catch (exception) {
                viewModelElement[loadingProp] = false;
                viewModelElement[disabledProp] = false;
            }
        };
    }
    AsyncClickWithLoadingCustomAttribute.prototype.attached = function () {
        this.element.addEventListener("click", this.internalClick, false);
    };
    AsyncClickWithLoadingCustomAttribute.prototype.detached = function () {
        this.element.removeEventListener("click", this.internalClick, false);
    };
    __decorate([
        bindable,
        __metadata("design:type", Function)
    ], AsyncClickWithLoadingCustomAttribute.prototype, "click", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], AsyncClickWithLoadingCustomAttribute.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], AsyncClickWithLoadingCustomAttribute.prototype, "disabledProp", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], AsyncClickWithLoadingCustomAttribute.prototype, "loadingProp", void 0);
    AsyncClickWithLoadingCustomAttribute = __decorate([
        noView(),
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [Element])
    ], AsyncClickWithLoadingCustomAttribute);
    return AsyncClickWithLoadingCustomAttribute;
}());
export { AsyncClickWithLoadingCustomAttribute };
